import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { usePeriod } from "@/context/PeriodContext";
import { money } from "@/lib/format";
import {
  TrendingUp, TrendingDown, Wallet, Coins, Landmark, FileWarning,
} from "lucide-react";

function StatTile({ label, value, icon: Icon, accent, testid }) {
  return (
    <div
      className="border rounded-xl p-4 bg-background shadow-elev-1 card-hover"
      data-testid={testid}
    >
      <div className="flex items-center justify-between text-muted-foreground mb-2">
        <span className="text-[10px] uppercase tracking-[0.14em] font-semibold">{label}</span>
        {Icon && (
          <div className="w-7 h-7 rounded-lg bg-muted/60 flex items-center justify-center">
            <Icon className="w-3.5 h-3.5" />
          </div>
        )}
      </div>
      <div className={`font-mono text-lg md:text-xl font-semibold tracking-[-0.02em] ${accent ? "text-primary" : ""}`}>
        {value}
      </div>
    </div>
  );
}

export default function TodayCards() {
  const { lang } = useI18n();
  const { periodKey } = usePeriod();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!periodKey) return;
    (async () => {
      try {
        const { data } = await api.get(`/dashboard/workspace?period=${periodKey}`);
        setData(data);
      } catch { /* ignore */ }
    })();
  }, [periodKey]);

  const t = (tr, de) => (lang === "de" ? de : tr);
  const today = data?.today || {};

  const items = [
    { key: "rev", label: t("Bugün Ciro", "Heute Umsatz"), value: money(today.revenue || 0), icon: TrendingUp, testid: "today-revenue" },
    { key: "exp", label: t("Bugün Gider", "Heute Ausgaben"), value: money(today.expenses || 0), icon: TrendingDown, testid: "today-expenses" },
    { key: "prof", label: t("Bugün Kâr", "Heute Gewinn"), value: money(today.profit || 0), icon: Wallet, accent: true, testid: "today-profit" },
    { key: "cash", label: t("Kasa", "Kasse"), value: money(today.cash_balance || 0), icon: Coins, testid: "today-cash" },
    { key: "bank", label: t("Banka", "Bank"), value: money(today.bank_balance || 0), icon: Landmark, testid: "today-bank" },
    { key: "ap", label: t("Açık Borç", "Offene Verb."), value: money(today.open_payables || 0), icon: FileWarning, testid: "today-payables" },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3" data-testid="today-cards">
      {items.map((it) => (
        <StatTile key={it.key} {...it} />
      ))}
    </div>
  );
}
